import { apiRequest } from "@/services/api-client";
import { CreateBoxInput, CreateBoxOutput } from "types/web-app";

export const createBox = (input: CreateBoxInput) =>
  apiRequest<CreateBoxOutput>("/box/create", {
    method: "POST",
    body: JSON.stringify(input),
  });
